module.exports = __webpack_public_path__ + "static/media/stripe-express-onboarding_4.b022f0b7.png";